import { Component, OnInit } from '@angular/core';
import { FinancialsService } from 'src/app/service/financials.service';
@Component({
  selector: 'app-ass-resources',
  templateUrl: './ass-resources.component.html',
  styleUrls: ['./ass-resources.component.css']
})
export class AssResourcesComponent implements OnInit {
 finYear: any = '';

  constructor(private financialService:FinancialsService) { }
  ngOnInit(): void {
    this.getFinYear();
  }
   getFinYear() {
    this.financialService.getCookie({}, 'financialYear').subscribe({
      next: (resp: any) => {
        this.finYear = resp.cookie;
        console.log(this.finYear," :this.finYear");
        this.getAllDocument(resp.cookie);
      },
      error: (err: any) => {
        window.alert('Some error occured!!!');
      }
    });
  }


  documentList:any[]=[];
    getAllDocument(finYear:string): void{
      this.financialService.post('get-user-document',{userType:'Assessor',financialYear:finYear}).subscribe({
        next:(resp:any)=>{
          console.log(resp," :Data resp");
          if(resp['status']=='success'){
            resp['result']?.filter((item:any)=>{
            let str = item.document.split('/')[3].split('.')[0];
            item['fileName']= str;
            item['financialYear'] = item.financialYear?.financialYear
            });
            console.log(resp);
            this.documentList = resp['result'];
          }
        }
      });
    }
  

  
    openFile(reportFile:string): void {
    const newUrl = reportFile.replace('http://13.235.172.47:3000', 'https://award.face-cii.in');
  const encodedUrl = encodeURI(newUrl);
    if (reportFile) {
            const a = document.createElement('a');
            a.href = encodedUrl;
            a.target = '_blank'; // Open in new tab
            a.rel = 'noopener';  // Recommended for security
            a.click();
          }
    
  }
    

}
